var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"be-btn be-btn-default",on:{"click":_vm.click}},[_c('i',{class:_vm.icon + ' be-icon'})])}
var staticRenderFns = []

export { render, staticRenderFns }